import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type TAmplitudeParams = {
    deviceId: string;
    eventProperties: {
        [k: string]: string;
        formId: string;
        title: string;
        url: string;
    };
    eventType: 'site_formRequest_welcomePage' | 'site_formRequest_welcomePage_button';
    userId?: string;
};

export const sendAmplitudeEvent = async (params: TAmplitudeParams) => {
    const request: AxiosRequestConfig = {
        method: 'POST',
        url: `${process.env.ALFALEASING_SITE_HOST}/api/amplitude/`,
        // NOTE: без JSON.stringify так как отправляется на /catalog/api/amplitude/
        data: {
            device_id: params?.deviceId,
            event_type: params?.eventType,
            user_id: params?.userId,
            event_properties: {
                ...params.eventProperties,
            },
        },
    };

    const { data } = await axios(request);

    return data;
};
